import './header.style.sass';
import template from './header.tpl.pug';

class HeaderController {
    /* @ngInject */
    constructor() {
    }

    toggleNavigation() {
        this.navigationVisible = !this.navigationVisible;
    }

    closeNavigation() {
        this.navigationVisible = false;
    }
}

export default {
    selector: 'dbPHeader',
    template: template(),
    controller: HeaderController
};



// WEBPACK FOOTER //
// ./src/presentation/component/header/header.cmpt.js